import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    data: "",
    remainingQueries: null,
    loadingStatus: "idle",
    error: null,
    activePeriod: null
};

export const fetchAiReport = createAsyncThunk(
    "aiReport/fetchAiReport",
    async ({ token, dateInterval, customDateRange }, { rejectWithValue }) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            };

            let url = `${APP_URL}/reports/ai-report`;

            if (customDateRange) {
                url += `?custom_date_range=${encodeURIComponent(customDateRange)}`;
            } else if (dateInterval) {
                url += `?date_interval=${dateInterval}`;
            }

            const response = await request(
                url,
                "GET",
                null,
                customHeaders
            );

            return {
                data: response?.data || "",
                remainingQueries:
                    typeof response?.remaining_queries === "number"
                        ? response.remaining_queries
                        : null,
                activePeriod: customDateRange ? "custom" : dateInterval || null
            };
        } catch (error) {
            return rejectWithValue(error?.message || "error");
        }
    }
);

const aiReportSlice = createSlice({
    name: "aiReport",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAiReport.pending, (state) => {
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchAiReport.fulfilled, (state, action) => {
                state.data = action.payload?.data || "";
                state.remainingQueries = action.payload?.remainingQueries ?? null;
                state.activePeriod = action.payload?.activePeriod || null;
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchAiReport.rejected, (state, action) => {
                state.loadingStatus = "error";
                state.error = action.payload;
            });
    }
});

export default aiReportSlice.reducer;